import { apiFetch } from './core.js';

export const yunexpress = {
  dashboard: () => apiFetch('/yunexpress/dashboard'),
  pending: (params = {}) => {
    const q = new URLSearchParams();
    if (params.from) q.set('from', params.from);
    if (params.to) q.set('to', params.to);
    if (params.search) q.set('search', params.search);
    return apiFetch(`/yunexpress/pending?${q.toString()}`);
  },
  shipped: (params = {}) => {
    const q = new URLSearchParams();
    if (params.search) q.set('search', params.search);
    if (params.syncStatus) q.set('syncStatus', params.syncStatus);
    return apiFetch(`/yunexpress/shipped?${q.toString()}`);
  },
  salesBySku: (params = {}) => {
    const q = new URLSearchParams();
    if (params.from) q.set('from', params.from);
    if (params.to) q.set('to', params.to);
    return apiFetch(`/yunexpress/sales-by-sku?${q.toString()}`);
  },
  batches: (params = {}) => {
    const q = new URLSearchParams();
    if (params.status) q.set('status', params.status);
    return apiFetch(`/yunexpress/batches?${q.toString()}`);
  },
  getBatch: (id) => apiFetch(`/yunexpress/batches/${id}`),
  createBatch: (data) => apiFetch('/yunexpress/batches', { method: 'POST', body: JSON.stringify(data) }),
  syncBatch: (id) => apiFetch(`/yunexpress/batches/${id}/sync`, { method: 'POST' }),
  retryBatch: (id) => apiFetch(`/yunexpress/batches/${id}/retry-errors`, { method: 'POST' }),
  deleteBatch: (id) => apiFetch(`/yunexpress/batches/${id}`, { method: 'DELETE' }),
  removeOrder: (id) => apiFetch(`/yunexpress/orders/${id}/remove`, { method: 'DELETE' }),
  products: () => apiFetch('/yunexpress/products'),
  remoteProducts: (params = {}) => {
    const q = new URLSearchParams();
    if (params.search) q.set('search', params.search);
    return apiFetch(`/yunexpress/remote-products?${q.toString()}`);
  },
  updateProductCost: (id, productionCost) => apiFetch(`/yunexpress/products/${id}/cost`, { method: 'PUT', body: JSON.stringify({ productionCost }) }),
  toggleProductExclusion: (id) => apiFetch(`/yunexpress/products/${id}/toggle-exclusion`, { method: 'POST' }),
  updateRemoteProductStatus: (sku, status) => apiFetch(`/yunexpress/remote-products/${encodeURIComponent(sku)}/status`, { method: 'POST', body: JSON.stringify({ status }) }),
  cancelOrder: (id, reason) => apiFetch(`/yunexpress/orders/${id}/cancel`, { method: 'POST', body: JSON.stringify({ reason }) }),
  resetOrder: (id) => apiFetch(`/yunexpress/orders/${id}/reset`, { method: 'POST' }),
  syncOrder: (id) => apiFetch(`/orders/${id}/yunexpress/sync`, { method: 'POST' }),
  syncRemoteProducts: () => apiFetch('/yunexpress/remote-products/sync', { method: 'POST' }),
  updateRemoteManualAction: (sku, action, note) => apiFetch(`/yunexpress/remote-products/${encodeURIComponent(sku)}/manual`, { method: 'POST', body: JSON.stringify({ action, note }) }),
  remoteProductsManual: (params = {}) => {
    const q = new URLSearchParams();
    if (params.search) q.set('search', params.search);
    if (params.manualStatus) q.set('manualStatus', params.manualStatus);
    return apiFetch(`/yunexpress/remote-products-manual?${q.toString()}`);
  },
  getOrderShipments: (orderId) => apiFetch(`/yunexpress/orders/${orderId}/shipments`),
};

export const yunexpressNew = {
  systemSkus: {
    list: (params = {}) => {
      const q = new URLSearchParams();
      if (params.search) q.set('search', params.search);
      if (params.isEnabled) q.set('isEnabled', String(params.isEnabled));
      if (params.page) q.set('page', String(params.page));
      if (params.pageSize) q.set('pageSize', String(params.pageSize));
      return apiFetch(`/yunexpress-new/system-skus?${q.toString()}`);
    },
    get: (systemSku) => apiFetch(`/yunexpress-new/system-skus/${encodeURIComponent(systemSku)}`),
    getByProduct: (productId) => apiFetch(`/yunexpress-new/system-skus/by-product/${productId}`),
    create: (data) => apiFetch('/yunexpress-new/system-skus', { method: 'POST', body: JSON.stringify(data) }),
    update: (systemSku, data) => apiFetch(`/yunexpress-new/system-skus/${encodeURIComponent(systemSku)}`, { method: 'PUT', body: JSON.stringify({ systemSku, ...data }) }),
    delete: (systemSku) => apiFetch(`/yunexpress-new/system-skus/${encodeURIComponent(systemSku)}`, { method: 'DELETE' }),
    validate: (data) => apiFetch(`/yunexpress-new/system-skus/${encodeURIComponent(data.systemSku)}/validate`, { method: 'POST' }),
    sync: (systemSku) => apiFetch(`/yunexpress-new/system-skus/${encodeURIComponent(systemSku)}/sync`, { method: 'POST' }),
    stats: () => apiFetch('/yunexpress-new/system-skus/stats'),
  },
  skuMappings: {
    list: (params = {}) => {
      const q = new URLSearchParams();
      if (params.search) q.set('search', params.search);
      if (params.source) q.set('source', params.source);
      if (params.isEnabled) q.set('isEnabled', String(params.isEnabled));
      return apiFetch(`/yunexpress-new/sku-mappings?${q.toString()}`);
    },
    get: (id) => apiFetch(`/yunexpress-new/sku-mappings/${id}`),
    create: (data) => apiFetch('/yunexpress-new/sku-mappings', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => apiFetch(`/yunexpress-new/sku-mappings/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id) => apiFetch(`/yunexpress-new/sku-mappings/${id}`, { method: 'DELETE' }),
    validate: (id) => apiFetch(`/yunexpress-new/sku-mappings/${id}/validate`, { method: 'POST' }),
    stats: () => apiFetch('/yunexpress-new/sku-mappings/stats'),
  },
  orderDrafts: {
    list: (params = {}) => {
      const q = new URLSearchParams();
      if (params.status) q.set('status', params.status);
      if (params.isApproved !== undefined) q.set('isApproved', String(params.isApproved));
      if (params.search) q.set('search', params.search);
      if (params.page) q.set('page', String(params.page));
      if (params.pageSize) q.set('pageSize', String(params.pageSize));
      return apiFetch(`/yunexpress-new/order-drafts?${q.toString()}`);
    },
    get: (orderId) => apiFetch(`/yunexpress-new/order-drafts/${orderId}`),
    bootstrap: (orderId) => apiFetch(`/yunexpress-new/order-drafts/${orderId}/bootstrap`, { method: 'POST' }),
    update: (orderId, data) => apiFetch(`/yunexpress-new/order-drafts/${orderId}`, { method: 'PUT', body: JSON.stringify(data) }),
    validate: (orderId) => apiFetch(`/yunexpress-new/order-drafts/${orderId}/validate`, { method: 'POST' }),
    approve: (orderId) => apiFetch(`/yunexpress-new/order-drafts/${orderId}/approve`, { method: 'POST' }),
    unapprove: (orderId) => apiFetch(`/yunexpress-new/order-drafts/${orderId}/unapprove`, { method: 'POST' }),
    sync: (orderId) => apiFetch(`/yunexpress-new/order-drafts/${orderId}/sync`, { method: 'POST' }),
    stats: () => apiFetch('/yunexpress-new/order-drafts/stats'),
    preparacion: (params = {}) => {
      const q = new URLSearchParams();
      if (params.search) q.set('search', params.search);
      if (params.status) q.set('status', params.status);
      return apiFetch(`/yunexpress-new/order-drafts/preparacion?${q.toString()}`);
    },
  },
};
